import { createReducer } from '@reduxjs/toolkit';
import { getActionStringWithoutState } from '@redux/reduxUtils';
import { getSystemPromptCategoriesAction } from './caregiverAssistantActions';
import { CaregiverAssistantState } from './caregiverAssistantTypes';

export const initialCaregiverAssistantState: CaregiverAssistantState = {
  systemPromptCategories: [],
  isLoading: {},
  error: {},
  success: {}
};

export default createReducer(initialCaregiverAssistantState, (builder) => {
  builder.addCase(getSystemPromptCategoriesAction.start, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = true;
    delete state.error[tag];
  });
  builder.addCase(getSystemPromptCategoriesAction.success, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    delete state.error[tag];
    state.success[tag] = true;
    state.systemPromptCategories = action.payload ?? [];
  });
  builder.addCase(getSystemPromptCategoriesAction.fail, (state, action) => {
    const tag = getActionStringWithoutState(action.type);
    state.isLoading[tag] = false;
    state.error[tag] = {
      message: action.payload?.message,
      status: action.payload?.status
    };
  });
});
